export default "__VITE_ASSET__BljYJAhM__"